module.exports = __webpack_public_path__ + "img/about_2023.082679a5.png";